<template>
  <InteractionStep :disabled-next="!checked"
                   :pending-next="pendingSave"
                   @next="onSave">
    <template v-slot:content>
      <div class="step-text" style="margin-bottom: 3rem">
        <div v-html="$tInteraction('send_documents_by_nova_poshta_text')"
             class="step-text__text text"></div>
      </div>

      <div class="step-confirm">
        <div class="step-confirm__alert">
          <h4 class="step-confirm__title">{{ $tInteraction('Documents are on the way for you') }}</h4>
          <div class="step-confirm__text text">
            <p>{{
                $tInteraction('We have prepared and sent you a package of documents that must be sent to the visa center')
              }}</p>
          </div>
        </div>

        <div class="step-confirm__center">
          <h4 class="step-confirm__title">{{ $tInteraction('Confirm sending documents to the visa center') }}</h4>

          <label class="step-confirm__checkbox checkbox">
            <input type="radio"
                   name="type-option"
                   v-model="checked"
                   value="1"
                   hidden>
            <span class="checkbox__mark">
              <BaseSvg name="ico-check"/>
            </span>
            <span class="checkbox__text">{{ $tInteraction('I have sent documents') }}</span>
          </label>
        </div>

      </div>
    </template>
  </InteractionStep>
</template>

<script>
  import InteractionStep from '@/components/interactions/InteractionStep'
  import {http} from '@/axios'
  import interactionStepMixin from "@/mixins/interactionStepMixin"

  export default {
    name: 'InteractionStepSentWaiting',
    mixins: [interactionStepMixin],
    components: {InteractionStep},
    data() {
      return {
        pendingSave: false,
        error: null,
        checked: false
      }
    },
    methods: {
      onSave() {
        this.error = null
        this.pendingSave = true

        const step = this.$store.state.interaction.step

        http.post(`/api/new-interaction/${this.$route.params.id}/${step}`, {
          i_send_docs_np: 1
        }).then(async () => {
          await this.$store.dispatch('interaction/loadInteraction')
        }).catch(e => {
          this.handleInteractionError(e)
        }).finally(() => {
          this.pendingSave = false
        })
      },
    },
  }
</script>

<style>

</style>
